import { useContext, useEffect, useState } from 'react'
import "./style.scss"
import { AuthContext } from "../../../context/auth";
import { assignRoleToUserApi, getRolesApi } from '../../../api';
import Dropdown from '../../Dropdown';

const Index = ({ setChangeRoleModal, selectedAdmin, setSelectedAdmin, fetchAdmins }) => {
    const { setNotification, setIsLoading, isLoading } = useContext(AuthContext)
    const [roles, setRoles] = useState([])
    const [role, setRole] = useState(null)
    const [isDisabled, setIsDisabled] = useState(false)

    const getRoles = () => {
        setIsLoading(true)
        getRolesApi().then(res => {
            if (res && res.data) {
                setIsLoading(false)
                const roles = res?.data?.roles || []
                const superadmin = {
                    id: '1',
                    name: 'Super Admin',
                }
                setRoles([superadmin, ...roles?.map(role => ({ id: role?.id, name: role?.name }))])
            }
        }).catch(err => {
            setIsLoading(false)
        })
    }

    useEffect(() => {
        getRoles()
        setRole({
            id: selectedAdmin?.teamRole?.id ?? 1,
            name: selectedAdmin?.teamRole?.name ?? 'Super Admin'
        })
    }, [selectedAdmin])

    const changeRole = () => {
        setIsLoading(true)
        assignRoleToUserApi(role?.id, selectedAdmin?.id).then(res => {
            if (res && res.data) {
                fetchAdmins()
                setChangeRoleModal(false)
                setSelectedAdmin(null)
                setIsLoading(false)
                setNotification({ type: 'success', message: 'Role changed successfully' })
            }
        }).catch(err => {
            setIsLoading(false)
            setNotification({ type: 'error', message: 'Something went wrong' })
        })
    }

    return (
        <div className="small-modal-wrapper">
            <div className="password-modal-content" style={{ padding: '20px' }}>
                <div style={{ position: 'relative', justifyContent: 'center', display: 'flex', width: '100%' }}>
                    <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#fff2e5', color: 'var(--primary-color)' }}>
                        <i class="fal fa-key"></i>
                    </span>
                    <span className='close' style={{ color: '#9a9a9a', top: 0, right: 0 }} onClick={() => {
                    setChangeRoleModal(false)
                    setSelectedAdmin(null)
                    }}><i className="fal fa-times"></i></span>
                </div>
                <h2>Change Role for {selectedAdmin?.first_name ? selectedAdmin?.first_name + " " + selectedAdmin?.last_name : 'Admin User'}</h2>
                <div className="form-container" style={{ width: '100%', marginBottom: '20px', marginTop: '10px' }}>
                <Dropdown label="Change Role" options={roles} value={role} onChange={(value) => setRole(value)} setIsDisabled={setIsDisabled} className={'dropdown'} optionType={'role'} />
                </div>
                <button className='btn'
                    disabled={isLoading || isDisabled || !role}
                    onClick={() => {
                        changeRole()
                    }}>Save</button>
                <button className='btn transparent' disabled={isDisabled} style={{ margin: 0 }} onClick={() => {
                    setChangeRoleModal(false)
                }}>Cancel</button>
            </div>
        </div>
    )
}

export default Index